"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "webLightTheme", {
    enumerable: true,
    get: function() {
        return webLightTheme;
    }
});
const _createLightTheme = require("../../utils/createLightTheme");
const _brandColors = require("../../global/brandColors");
const webLightTheme = (0, _createLightTheme.createLightTheme)(_brandColors.brandWeb);
